<template>
    <div>
        <station-location-view-information />
        <station-location-sensor-variable-card />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import StationLocationViewInformation from '@/components/station-location/StationLocationViewInformation.vue';
import StationLocationSensorVariableCard from '@/components/station-location/StationLocationSensorVariableCard.vue';

export default {
    name: 'StationLocationView',
    components: {
        'station-location-view-information': StationLocationViewInformation,
        'station-location-sensor-variable-card': StationLocationSensorVariableCard
    },
    async mounted() {
        const probeId = this.$route.params.probeId;
        const locationId = this.$route.params.locationId;
        await this.fetchStationLocation({probeId, locationId});
    },
    methods: {
        ...mapActions('stationLocation', ['fetchStationLocation']),
    },
};
</script>

<style scoped>

</style>